import React, { FC, useEffect, useState } from 'react';

import { Checkbox } from '@rbilabs/universal-components';

import { ProductListItem } from 'components/product-list-item';
import { NumberInput } from 'components/ucl/number-input';
import { theme } from 'styles/configure-theme';

import { AddExtraItemControlType, IAddExtrasContentItemProps } from './types';

const incrementorStyleProps = ({ disabled }: { disabled?: boolean }) => ({
  marginX: 0,
  padding: 1,
  borderColor: theme.token(disabled ? 'icon-disabled' : 'increment-active'),
  _icon: {
    color: theme.token(disabled ? 'icon-disabled' : 'increment-active'),
    size: 'xs',
  },
});

const displayValueStyleProps = () => ({
  minWidth: 8,
  width: 8,
  height: 8,
  marginX: 0,
});

export const AddExtrasContentItem: FC<React.PropsWithChildren<IAddExtrasContentItemProps>> = ({
  itemCalories,
  itemImage,
  itemName,
  index,
  isInCart,
  onChange,
  itemPrice,
  max,
  maxAmount,
}) => {
  const [checked, setChecked] = useState(false);

  const itemControl = maxAmount
    ? AddExtraItemControlType.NUMBER_INPUT
    : AddExtraItemControlType.CHECKBOX;

  const isCheckBox = itemControl === AddExtraItemControlType.CHECKBOX;

  const handleCheckbox = (isSelected: boolean) => {
    const isItemChecked = isSelected ? 1 : 0;
    onChange(isItemChecked);
    setChecked(prevState => !prevState);
  };

  useEffect(() => {
    if (isCheckBox && isInCart) {
      setChecked(isInCart);
    }
  }, [isInCart, maxAmount, isCheckBox]);

  const image = itemImage ? JSON.stringify(itemImage) : null;

  return (
    <ProductListItem
      isClickable={isCheckBox}
      onProductClick={() => isCheckBox && handleCheckbox(!checked)}
      controls={
        isCheckBox ? (
          <Checkbox
            value={`checkbox-${itemName}`}
            isChecked={checked}
            onChange={handleCheckbox}
            name={`checkbox-${itemName}`}
            accessibilityLabel={`checkbox-${itemName}`}
            testID="extra-content-item-checkbox"
          />
        ) : (
          <NumberInput
            hideNumberInput
            displayedValue={String(index)}
            value={index}
            onChange={onChange}
            max={max}
            ariaLabel={itemName}
            decrementAriaLabel={`decrement-${itemName}`}
            incrementAriaLabel={`increment-${itemName}`}
            testID="extra-content-item-number-input"
            incrementorStyleProps={incrementorStyleProps}
            displayValueStyleProps={displayValueStyleProps}
          />
        )
      }
      productProps={{
        calories: itemCalories,
        image,
        name: itemName,
        price: itemPrice,
      }}
    />
  );
};
